export default {"src":"/_next/static/media/EMAIL.981696ed.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};